"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { useLabels } from "@/lib/labels/LabelsProvider";
interface ConsentPreferencesProps {
  initialAnalytics: boolean;
  initialMarketing: boolean;
  onSave: (analytics: boolean, marketing: boolean) => void;
}
export function ConsentPreferences(t0) {
  const $ = _c(69);
  const {
    initialAnalytics,
    initialMarketing,
    onSave
  } = t0;
  const labels = useLabels();
  const consent = labels.consent;
  const [analytics, setAnalytics] = useState(initialAnalytics);
  const [marketing, setMarketing] = useState(initialMarketing);
  let t1;
  if ($[0] !== consent.categories.essential.title) {
    t1 = <p className="font-medium text-sm">{consent.categories.essential.title}</p>;
    $[0] = consent.categories.essential.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== consent.categories.essential.description) {
    t2 = <p className="text-xs text-muted-foreground">{consent.categories.essential.description}</p>;
    $[2] = consent.categories.essential.description;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="inline-block h-4 w-4 rounded-full bg-white transition-transform" style={{
      transform: "translateX(24px)"
    }} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== consent.categories.essential.title) {
    t5 = <button type="button" disabled={true} className="relative inline-flex h-6 w-11 shrink-0 items-center rounded-full bg-primary opacity-50 cursor-not-allowed" aria-label={consent.categories.essential.title}>{t4}</button>;
    $[8] = consent.categories.essential.title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex items-center justify-between">{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== consent.categories.analytics.title) {
    t7 = <p className="font-medium text-sm">{consent.categories.analytics.title}</p>;
    $[13] = consent.categories.analytics.title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== consent.categories.analytics.description) {
    t8 = <p className="text-xs text-muted-foreground">{consent.categories.analytics.description}</p>;
    $[15] = consent.categories.analytics.description;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div>{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== analytics) {
    t10 = () => setAnalytics(!analytics);
    $[20] = analytics;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = analytics ? "var(--primary)" : "color-mix(in srgb, var(--primary) 50%, transparent)";
  let t12;
  if ($[22] !== t11) {
    t12 = {
      backgroundColor: t11
    };
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = analytics ? "translateX(24px)" : "translateX(4px)";
  let t14;
  if ($[24] !== t13) {
    t14 = <span className="inline-block h-4 w-4 rounded-full bg-white transition-transform" style={{
      transform: t13
    }} />;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== analytics || $[27] !== consent.categories.analytics.title || $[28] !== t10 || $[29] !== t12 || $[30] !== t14) {
    t15 = <button type="button" role="switch" aria-checked={analytics} onClick={t10} className="relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full transition-colors" style={t12} aria-label={consent.categories.analytics.title}>{t14}</button>;
    $[26] = analytics;
    $[27] = consent.categories.analytics.title;
    $[28] = t10;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t15 || $[33] !== t9) {
    t16 = <div className="flex items-center justify-between">{t9}{t15}</div>;
    $[32] = t15;
    $[33] = t9;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== consent.categories.marketing.title) {
    t17 = <p className="font-medium text-sm">{consent.categories.marketing.title}</p>;
    $[35] = consent.categories.marketing.title;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== consent.categories.marketing.description) {
    t18 = <p className="text-xs text-muted-foreground">{consent.categories.marketing.description}</p>;
    $[37] = consent.categories.marketing.description;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t17 || $[40] !== t18) {
    t19 = <div>{t17}{t18}</div>;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== marketing) {
    t20 = () => setMarketing(!marketing);
    $[42] = marketing;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  const t21 = marketing ? "var(--primary)" : "color-mix(in srgb, var(--primary) 50%, transparent)";
  let t22;
  if ($[44] !== t21) {
    t22 = {
      backgroundColor: t21
    };
    $[44] = t21;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  const t23 = marketing ? "translateX(24px)" : "translateX(4px)";
  let t24;
  if ($[46] !== t23) {
    t24 = <span className="inline-block h-4 w-4 rounded-full bg-white transition-transform" style={{
      transform: t23
    }} />;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== consent.categories.marketing.title || $[49] !== marketing || $[50] !== t20 || $[51] !== t22 || $[52] !== t24) {
    t25 = <button type="button" role="switch" aria-checked={marketing} onClick={t20} className="relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full transition-colors" style={t22} aria-label={consent.categories.marketing.title}>{t24}</button>;
    $[48] = consent.categories.marketing.title;
    $[49] = marketing;
    $[50] = t20;
    $[51] = t22;
    $[52] = t24;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t19 || $[55] !== t25) {
    t26 = <div className="flex items-center justify-between">{t19}{t25}</div>;
    $[54] = t19;
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== analytics || $[58] !== marketing || $[59] !== onSave) {
    t27 = () => onSave(analytics, marketing);
    $[57] = analytics;
    $[58] = marketing;
    $[59] = onSave;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== consent.save || $[62] !== t27) {
    t28 = <button type="button" onClick={t27} className="cursor-pointer w-full py-2 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:opacity-90 transition">{consent.save}</button>;
    $[61] = consent.save;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== t16 || $[65] !== t26 || $[66] !== t28 || $[67] !== t6) {
    t29 = <div className="space-y-4 pt-4 border-t border-border">{t6}{t16}{t26}{t28}</div>;
    $[64] = t16;
    $[65] = t26;
    $[66] = t28;
    $[67] = t6;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  return t29;
}